"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUploadErrorAlert = void 0;
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireDefault(require("react"));
var _i18n = require("../../../i18n/i18n");
var _useTheme = require("../../../theme/utils/useTheme");
var _helpers = require("../helpers");
var _ErrorContainerStyled = require("../styled/ErrorContainerStyled");
var _ErrorSpanStyled = require("../styled/ErrorSpanStyled");
var _imageUploaderTheme = require("../styled/imageUploaderTheme");
const ImageUploadErrorAlertBase = _ref => {
  let {
    acceptableFileTypes,
    error,
    i18n,
    minBytes,
    maxBytes,
    clientId
  } = _ref;
  const minFileSizeStr = (0, _helpers.getFileSizeInNearestUnit)(minBytes);
  const maxFileSizeStr = (0, _helpers.getFileSizeInNearestUnit)(maxBytes);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const getErrorText = () => {
    switch (error.type) {
      case "SMALLER_THAN_MIN_SIZE":
        return i18n._( /*i18n*/"Sorry, \"{fileName}\" is smaller than {minFileSize} and can't be uploaded. Please upload a file that's {minFileSize} or larger.", {
          fileName: error.fileName,
          minFileSize: minFileSizeStr
        });
      case "LARGER_THAN_MAX_SIZE":
        return i18n._( /*i18n*/"Sorry, \"{fileName}\" is larger than {maxFileSize} and can't be uploaded. Please upload a file that's {maxFileSize} or smaller.", {
          fileName: error.fileName,
          maxFileSize: maxFileSizeStr
        });
      case "UNSUPPORTED_FILE_TYPE":
        return i18n._( /*i18n*/"Sorry, this image format isn't supported. Please provide a {fileTypes}.", {
          fileTypes: new Intl.ListFormat(i18n.locale, {
            style: "long",
            type: "disjunction"
          }).format(acceptableFileTypes)
        });
      default:
        return "";
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ErrorContainerStyled.ErrorContainerStyled, {
    clientId: (0, _lodestarUtils.getClientId)(clientId, "error-container"),
    orientation: "row",
    space: "xxSmall",
    "aria-live": "polite"
  }, /*#__PURE__*/_react.default.createElement(_lodestarIcons.AlertErrorAltIcon, {
    color: _imageUploaderTheme.imageUploaderTheme.errorSpan.color(themeMode),
    size: "small"
  }), /*#__PURE__*/_react.default.createElement(_ErrorSpanStyled.ErrorSpanStyled, {
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, "error-message"),
    themeMode: themeMode
  }, getErrorText()));
};
const ImageUploadErrorAlert = (0, _i18n.withI18n)(ImageUploadErrorAlertBase);
exports.ImageUploadErrorAlert = ImageUploadErrorAlert;
//# sourceMappingURL=ImageUploadErrorAlert.js.map